import { formFieldValue, formSelectorValues } from '../selectors/formFieldValue';

export const getAdditionalFormField = function (form, fieldName) {
  const selector = `input[name="${fieldName}"]:checked, select[name="${fieldName}"],\
   input[name="${fieldName}"]:not([type="radio"]):not([type="checkbox"]),\
   textarea[name="${fieldName}"]`;
  const values = formSelectorValues(form, selector);
  if (values.length) return values.join();
};

/**
 * Wizard leadform answers used by Sales and BI
 * This function creates a hash of all the wizard answers
 *
 * @param {element} form Form currently being validated
 * @returns {hash} hash of Wizard panel ids (keys) and user's answers (values)
 */
export const getAdditionalFormFields = function (form) {
  const fieldNames = formFieldValue(form, 'spells', '').split(',');
  return fieldNames.reduce((memo, fieldName) => {
    const value = getAdditionalFormField(form, fieldName);
    if (value !== undefined && value !== '') memo[fieldName] = value;
    return memo;
  }, {});
};

/**
 * Sales requires the answers in the contacts.message field as a string
 *
 * @param {hash} additionalFormFields Hash of form fields
 * @returns {string} string of Wizard answers like "panel-name: answer | panel-name: answer | ..."
 */
export const additionalFormFieldsAsString = function (additionalFormFields) {
  let array = [];
  for (let key in additionalFormFields) {
    array.push(`${key}: ${additionalFormFields[key]}`);
  }
  return array.join(' | ');
};

/**
 * BI requires the answers as a hash at root level as there is currently no support
 * for nested hashes in the 'anything goes' params
 *
 * @param {hash} additionalFormFields Hash of form fields
 * @returns {string} hash of Wizard answers like { "lead_form.panel_name": "answer", ... }
 */
export const additionalFormFieldsAsHash = function (additionalFormFields) {
  let hash = {};
  for (let key in additionalFormFields) {
    let transformedKey = `lead_form.${key.replace('-', '_')}`;
    hash[transformedKey] = additionalFormFields[key];
  }
  return hash;
};



// WEBPACK FOOTER //
// ./client/app/scripts/principles/form/additionalFormFields.js